import { render, staticRenderFns } from "./ReviewReturnSummary.vue?vue&type=template&id=2865092e&"
import script from "./ReviewReturnSummary.vue?vue&type=script&lang=js&"
export * from "./ReviewReturnSummary.vue?vue&type=script&lang=js&"
import style0 from "./ReviewReturnSummary.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1751410358/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2865092e')) {
      api.createRecord('2865092e', component.options)
    } else {
      api.reload('2865092e', component.options)
    }
    module.hot.accept("./ReviewReturnSummary.vue?vue&type=template&id=2865092e&", function () {
      api.rerender('2865092e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/Customer/OrderWidget/Return/ReviewReturnSummary.vue"
export default component.exports